import CloseIcon from '@mui/icons-material/Close';
import SearchIcon from '@mui/icons-material/Search';
import { Box, IconButton, InputAdornment, TextField, ToggleButton, ToggleButtonGroup } from '@mui/material';
import React from 'react';
import { inputSx, useDynamicStyles } from 'src/components/dynamicCatalogStyles';

const STATUS_FILTERS = [
  { value: 'all', label: 'Tümü' },
  { value: 'active', label: 'Aktif' },
  { value: 'passive', label: 'Pasif' }
];

const normalize = (v) => (v === null || v === undefined ? '' : v.toString().toLocaleLowerCase('tr-TR'));

// Arama + Aktif/Pasif filtresini satırlara uygular (sadece ekrandaki listede, API'ye gitmez)
export function filterDynamicRows(rows, { searchText, statusFilter, searchFields, isActive }) {
  const q = normalize(searchText).trim();
  return (rows || []).filter((r) => {
    if (isActive && statusFilter === 'active' && !isActive(r)) return false;
    if (isActive && statusFilter === 'passive' && isActive(r)) return false;
    if (!q) return true;
    return searchFields.some((f) => normalize(r[f]).includes(q));
  });
}

// Liste ekranlarının üstündeki arama / durum filtresi çubuğu
function DynamicListToolbar({
  searchText,
  onSearchChange,
  placeholder = 'Ara',
  statusFilter,
  onStatusFilterChange,
  shownCount,
  children
}) {
  const classes = useDynamicStyles();
  const filtered = !!searchText || (statusFilter && statusFilter !== 'all');

  return (
    <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1.5, alignItems: 'center', p: '12px 16px', borderBottom: '1px solid #f0f0f0' }}>
      <TextField
        size="small"
        placeholder={placeholder}
        value={searchText}
        onChange={(e) => onSearchChange(e.target.value)}
        sx={{ ...inputSx, width: 280, maxWidth: '100%' }}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <SearchIcon sx={{ fontSize: 18, color: '#90a4ae' }} />
            </InputAdornment>
          ),
          endAdornment: searchText ? (
            <InputAdornment position="end">
              <IconButton size="small" onClick={() => onSearchChange('')}>
                <CloseIcon sx={{ fontSize: 16 }} />
              </IconButton>
            </InputAdornment>
          ) : null
        }}
      />
      {onStatusFilterChange && (
        <Box sx={{ width: 240 }}>
          <ToggleButtonGroup
            exclusive
            size="small"
            className={classes.toggleGroup}
            value={statusFilter}
            onChange={(e, v) => v !== null && onStatusFilterChange(v)}
          >
            {STATUS_FILTERS.map((f) => (
              <ToggleButton key={f.value} value={f.value}>{f.label}</ToggleButton>
            ))}
          </ToggleButtonGroup>
        </Box>
      )}
      {children}
      {filtered && shownCount !== undefined && (
        <Box sx={{ fontSize: '11px', color: '#78909c', ml: 'auto' }}>
          {shownCount} kayıt gösteriliyor
        </Box>
      )}
    </Box>
  );
}

export default DynamicListToolbar;
